<template>
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.16675 13C2.16675 7.01692 7.017 2.16667 13.0001 2.16667C15.8733 2.16667 18.6288 3.30804 20.6604 5.33968C22.692 7.37133 23.8334 10.1268 23.8334 13C23.8334 18.9831 18.9832 23.8333 13.0001 23.8333C7.017 23.8333 2.16675 18.9831 2.16675 13ZM11.6242 16.6292L17.7126 10.5408C17.9121 10.3316 17.9121 10.0026 17.7126 9.79334L17.1384 9.21917C16.9278 9.01272 16.5907 9.01272 16.3801 9.21917L11.2451 14.3542L9.62008 12.74C9.52179 12.6353 9.38455 12.5759 9.24091 12.5759C9.09728 12.5759 8.96004 12.6353 8.86175 12.74L8.28758 13.3142C8.18504 13.4159 8.12736 13.5543 8.12736 13.6988C8.12736 13.8432 8.18504 13.9816 8.28758 14.0833L10.8659 16.6292C10.9642 16.7339 11.1014 16.7933 11.2451 16.7933C11.3887 16.7933 11.526 16.7339 11.6242 16.6292Z"
      :fill="completed ? 'white' : '#87929D'"
    />
  </svg>
</template>

<script>
export default {
  props: ["completed"]
};
</script>
